import {useCallback, useEffect, useState} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {sessionCache} from "@pg-rp/session-cache";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";
import {CREDIT_OFFERS_UNLOCKED} from "../../app/constants/storage_keys";

const creditPaywallAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.CREDIT_CALCULATOR_PAYWALL);

const UNLOCK_EVENT = "credit-offers-unlocked";

export const useCreditPaywallAbTest = () => {
    const {abTestVariant} = useABTest(creditPaywallAbTestInstance);
    const [areOffersUnlocked, setAreOffersUnlocked] = useState<boolean>(() => {
        return sessionCache.get<boolean>(CREDIT_OFFERS_UNLOCKED) ?? false;
    });

    useEffect(() => {
        const handleUnlock = () => {
            setAreOffersUnlocked(true);
        };

        window.addEventListener(UNLOCK_EVENT, handleUnlock);

        return () => {
            window.removeEventListener(UNLOCK_EVENT, handleUnlock);
        };
    }, []);

    const unlockOffers = useCallback(() => {
        sessionCache.set(CREDIT_OFFERS_UNLOCKED, true);
        setAreOffersUnlocked(true);

        window.dispatchEvent(new Event(UNLOCK_EVENT));
    }, []);

    const isPaywallVariant = abTestVariant === 1;

    return {
        isPaywallVariant,
        areOffersUnlocked,
        unlockOffers
    };
};
import {useCallback, useEffect, useState} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {sessionCache} from "@pg-rp/session-cache";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";
import {CREDIT_OFFERS_UNLOCKED} from "../../app/constants/storage_keys";

const creditPaywallAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.CREDIT_CALCULATOR_PAYWALL);

const UNLOCK_EVENT = "credit-offers-unlocked";

export const useCreditPaywallAbTest = () => {
    const {abTestVariant} = useABTest(creditPaywallAbTestInstance);
    const [areOffersUnlocked, setAreOffersUnlocked] = useState<boolean>(() => {
        return sessionCache.get<boolean>(CREDIT_OFFERS_UNLOCKED) ?? false;
    });

    useEffect(() => {
        const handleUnlock = () => {
            setAreOffersUnlocked(true);
        };

        window.addEventListener(UNLOCK_EVENT, handleUnlock);

        return () => {
            window.removeEventListener(UNLOCK_EVENT, handleUnlock);
        };
    }, []);

    const unlockOffers = useCallback(() => {
        sessionCache.set(CREDIT_OFFERS_UNLOCKED, true);
        setAreOffersUnlocked(true);

        window.dispatchEvent(new Event(UNLOCK_EVENT));
    }, []);

    const isPaywallVariant = abTestVariant === 1;

    return {
        isPaywallVariant,
        areOffersUnlocked,
        unlockOffers
    };
};
